module.exports = __webpack_public_path__ + "static/media/amazon-logo.a6319a18.svg";